import { http } from 'http';

export default {
  saveData: (guid, container, data) =>
    http.patch(`/prospects/onboarding/SaveDocumentsProspect/${container}/${guid}`, data, {
      headers: {
        'content-type': 'application/json-patch+json'
      }
    })
};
